import script from "./top.vue?vue&type=script&setup=true&lang=js"
export * from "./top.vue?vue&type=script&setup=true&lang=js"

import "./top.vue?vue&type=style&index=0&id=7149a936&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7149a936"]])

export default __exports__